// EMBRYO ACTIONS
export const ADD_TO_CART = 'ADD_TO_CART'
export const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST'
export const REMOVE_FROM_WISHLIST = 'REMOVE_FROM_WISHLIST'
export const MOVE_WISHLISTITEM_TO_CART = 'MOVE_WISHLISTITEM_TO_CART'
export const FINAL_PAYMENT = 'FINAL_PAYMENT'
export const HIDE_ALERT = 'HIDE_ALERT'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const UPDATE_PRODUCT_QUANTITY = 'UPDATE_PRODUCT_QUANTITY'
export const CHANGE_CURRENCY = 'CHANGE_CURRENCY'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const RTL_LAYOUT = 'RTL_LAYOUT'
export const COLLAPSED_SIDEBAR = 'COLLAPSED_SIDEBAR'
export const DELETE_USER = 'DELETE_USER'
export const ADD_NEW_USER = 'ADD_NEW_USER'

// SHERWOOD ACTIONS
export const FETCH_ABOUT_TEMPLATE = 'FETCH_ABOUT_TEMPLATE'
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS'
export const FETCH_PRODUCT_DETAILS_SKU = 'FETCH_PRODUCT_DETAILS_SKU'
export const FETCH_PORTAL_CATEGORY_PRODUCTS = 'FETCH_PORTAL_CATEGORY_PRODUCTS'
export const FETCH_PORTAL_FEATURED_CATEGORIES = 'FETCH_PORTAL_FEATURED_CATEGORIES'
export const FETCH_PORTAL_FEATURED_PRODUCTS = 'FETCH_PORTAL_FEATURED_PRODUCTS'
export const FETCH_PRODUCT_SUGGESTIONS = 'FETCH_PRODUCT_SUGGESTIONS'
export const SAVE_SEARCH_QUERY = 'SAVE_SEARCH_QUERY'
export const SAVE_PRODUCT_SUGGESTIONS = 'SAVE_PRODUCT_SUGGESTIONS'

// USERS
export const CREATE_USER = 'CREATE_USER'
export const FETCH_USER = 'FETCH_USER'
export const VERIFY_PASSWORD_TOKEN_SUCCESS = 'VERIFY_PASSWORD_TOKEN_SUCCESS'
export const VERIFY_PASSWORD_TOKEN_FAILURE = 'VERIFY_PASSWORD_TOKEN_FAILURE'

// ERRORS
export const CREATE_SESSION_ERROR = 'CREATE_SESSION_ERROR'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'
export const CREATE_CART_ERROR = 'CREATE_CART_ERROR'
export const PRODUCT_ERROR = 'PRODUCT_ERROR'

// SUCCESS
export const CREATE_SUCCESS_MESSAGE = 'CREATE_SUCCESS_MESSAGE'

// CART
export const FETCH_PRODUCT_BUNDLE_SELECTIONS = 'FETCH_PRODUCT_BUNDLE_SELECTIONS'
export const CREATE_ORDER = 'CREATE_ORDER'
export const FETCH_PRODUCT_DETAILS = 'FETCH_PRODUCT_DETAILS'
export const FETCH_BUNDLE = 'FETCH_BUNDLE'
export const ADD_PRODUCT_SKU_ID_TO_PRODUCT = 'ADD_PRODUCT_SKU_ID_TO_PRODUCT'

// CUSTOMER ADDRESSES
export const FETCH_CUSTOMER_ADDRESSES = 'FETCH_CUSTOMER_ADDRESSES'
export const CREATE_CUSTOMER_ADDRESS = 'CREATE_CUSTOMER_ADDRESS'
export const UPDATE_CUSTOMER_ADDRESS = 'UPDATE_CUSTOMER_ADDRESS'
export const DELETE_CUSTOMER_ADDRESS = 'DELETE_CUSTOMER_ADDRESS'
export const ADD_GUEST_ADDRESS = 'ADD_GUEST_ADDRESS'
export const CLEAR_GUEST_ADDRESSES = 'CLEAR_GUEST_ADDRESSES'
export const FETCH_MANAGED_CUSTOMER_ADDRESSES = 'FETCH_MANAGED_CUSTOMER_ADDRESSES'
export const FETCH_MANAGED_CUSTOMER_ADDRESSES_ERROR = 'FETCH_MANAGED_CUSTOMER_ADDRESSES_ERROR'
export const CLEAR_MANAGED_CUSTOMER_ADDRESSES_ERROR = 'CLEAR_MANAGED_CUSTOMER_ADDRESSES_ERROR'
export const CART_MULTIPLE_MANAGED_CUSTOMER_ADDRESSES = 'CART_MULTIPLE_MANAGED_CUSTOMER_ADDRESSES'

// ORDERS
export const FETCH_CLIENT_ORDERS = 'FETCH_CLIENT_ORDERS'
export const UPDATE_ORDER = 'UPDATE_ORDER'
export const STOCK_CHECK_BULK_FAILURE = 'STOCK_CHECK_BULK_FAILURE'
export const FETCH_ORDER_INVOICE = 'FETCH_ORDER_INVOICE'

//SHIPPING QUOTE
export const FETCH_SHIPPING_QUOTE_ERROR = 'FETCH_SHIPPING_QUOTE_ERROR'
export const CREATE_CODE_ERROR = 'CREATE_CODE_ERROR'
export const CREATE_CODE_SUCCESS = 'CREATE_CODE_SUCCESS'
export const CLEAR_SUCCESS = 'CLEAR_SUCCESS'
export const CREATE_ORDER_FALLBACK = 'CREATE_ORDER_FALLBACK'
export const REMOVE_FALLBACK = 'REMOVE_FALLBACK'
export const CLEAR_CODE_ERRORS = 'CLEAR_CODE_ERRORS'
export const TAX_ERROR = 'TAX_ERROR'
export const CLEAR_TAX_ERROR = 'CLEAR_TAX_ERROR'
export const FETCH_ORDER_DETAILS = 'FETCH_ORDER_DETAILS'

// PRODUCT
export const FETCH_INVENTORY = 'FETCH_INVENTORY'
export const INVENTORY_LOADING = 'INVENTORY_LOADING'

// ADMIN USER AREA
export const FETCH_ADMIN_USER_ORDER_APPROVALS = 'FETCH_ADMIN_USER_ORDER_APPROVALS'
